import { useNavigate } from "react-router";

import ApplicationPage from "../components/ApplicationPage";
import Application from "../domain/Application";
import ApplicationEditor from "../features/ApplicationEditor";

export default function CreateApplication() {
    const navigate = useNavigate();

    function onSave(application: Application) {
        navigate(`../${ application.domain }`);
    }

    return (
        <ApplicationPage>
            <header>
                <span>Application</span>
            </header>
            <ApplicationEditor
                application={ new Application({}) }
                onSave={ onSave }
            />
        </ApplicationPage>
    );
}
